import { data, plural } from '../util/formato';

export interface Vigencia {
  readonly assinadoEm: string | null;
  readonly meses: number | null;
  /** Calculado pelo servidor — a tela não refaz a conta. */
  readonly terminaEm: string | null;
  readonly diasRestantes: number | null;
  readonly situacao: 'sem_contrato' | 'vigente' | 'vencendo' | 'vencido';
}

/**
 * A vigência do contrato, em duas linhas.
 *
 * O QUE APARECE É A DATA DO FIM, não a da assinatura: a pergunta é "quando acaba",
 * e obrigar a somar doze meses de cabeça a cada olhada é o que faz ninguém olhar.
 * A assinatura fica na linha de baixo, menor, para quem precisar conferir.
 *
 * Vencido e vencendo mudam de cor. Contrato sem prazo não é falha nem alarme: há
 * clínica que trabalha assim, e um aviso vermelho ali ensinaria a ignorar o vermelho.
 */
export function VigenciaDoContrato({
  contrato,
}: {
  contrato: Vigencia;
}) {
  if (contrato.situacao === 'sem_contrato') {
    return (
      <span className="text-[color:var(--texto-tenue)]">
        {contrato.assinadoEm
          ? `assinado em ${data(contrato.assinadoEm)} · sem prazo`
          : 'não informado'}
      </span>
    );
  }

  const dias = contrato.diasRestantes ?? 0;
  const cor =
    contrato.situacao === 'vencido'
      ? 'var(--color-vencido)'
      : contrato.situacao === 'vencendo'
        ? 'var(--color-atencao)'
        : 'var(--texto)';

  return (
    <>
      <span className="tabular" style={{ color: cor }}>
        até {data(contrato.terminaEm)}
      </span>
      <span className="block text-xs" style={{ color: cor }}>
        {contrato.situacao === 'vencido'
          ? `venceu há ${plural(Math.abs(dias), 'dia', 'dias')}`
          : dias === 0
            ? 'vence hoje'
            : dias === 1
              ? 'falta 1 dia'
              : `faltam ${plural(dias, 'dia', 'dias')}`}
        <span className="text-[color:var(--texto-tenue)]">
          {' '}
          · {plural(contrato.meses ?? 0, 'mês', 'meses')} desde {data(contrato.assinadoEm)}
        </span>
      </span>
    </>
  );
}
